import * as actionTypes from "./actionTypes";
import * as actions from "./index";
import MediaType from "Flow2/util/MediaFile";
import ClipUtil from "Flow2/util/Clip";
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";

export const getRoomsStart = () => {
  return {
    type: actionTypes.GET_ROOMS_START
  };
};

export const getDeletedRoomsStart = () => {
  return {
    type: actionTypes.GET_DELETED_ROOMS_START
  };
};

export const getRoomsSuccess = rooms => {
  return {
    type: actionTypes.GET_ROOMS_SUCCESS,
    rooms: rooms
  };
};

export const getDeletedRoomsSuccess = projects => {
  return {
    type: actionTypes.GET_DELETED_ROOMS_SUCCESS,
    deletedRooms: projects
  };
};

export const getDeletedRoomsFail = projects => {
  return {
    type: actionTypes.GET_DELETED_ROOMS_FAIL,
    deletedRooms: projects
  };
};

export const getRoomsFail = error => {
  return {
    type: actionTypes.GET_ROOMS_FAIL,
    error: error
  };
};

export const getRooms = () => {
  return (dispatch, getState) => {
    dispatch(getRoomsStart());
    window.flow
      .getShowroomsForCurrentUser()
      .then(res => {
        if (res.showroom && res.showroom.elements) {
          dispatch(getRoomsSuccess(res.showroom.elements));
        } else {
          dispatch(getRoomsFail(res.message));
        }
      })
      .catch(res => {
        dispatch(getRoomsFail(res.message));
        dispatch(actions.applicationError(res.message));
      });
  };
};

export const getDeletedRooms = () => {
  return dispatch => {
    // dispatch(getDeletedRoomsStart());
    window.flow
      .getShowroomsByFields([
        { field: "projecttype", type: "=", value: "room_delete", order: "name" }
      ])
      .then(res => {
        dispatch(getDeletedRoomsSuccess(res.showroom.elements));
      })
      .catch(res => {
        dispatch(getDeletedRoomsFail(res.message));
        dispatch(actions.applicationError(res.message));
      });
  };
};

export const newRoomStart = () => {
  return {
    type: actionTypes.NEW_ROOM_START
  };
};

export const newRoomSuccess = room => {
  return {
    type: actionTypes.NEW_ROOM_SUCCESS,
    payload: { room: room }
  };
};

export const newRoomFail = error => {
  return {
    type: actionTypes.NEW_ROOM_FAIL,
    error: error
  };
};

export function saveNewRoom(metadata) {
  return (dispatch, getState) => {
    dispatch(newRoomStart());
    window.flow
      .newShowroom(metadata)
      .then(res => {
        dispatch(newRoomSuccess(res));
        dispatch(actions.getRooms());

        dispatch(actions.getRoomLimit(getState().app.modules.modules));
      })
      .catch(res => {
        dispatch(newRoomFail(res.message));
        dispatch(actions.applicationError(res.message));
      });
  };
}

export function saveNewRoomForUpload(metadata) {
  return (dispatch, getState) => {
    dispatch(newRoomStart());
    window.flow
      .newShowroom(metadata)
      .then(res => {
        dispatch(newRoomSuccess(res));
        dispatch(actions.getRooms());

        dispatch(actions.getRoomLimit(getState().app.modules.modules));

        if (res.data) dispatch(actions.setNewData({ project: res.data }));
      })
      .catch(res => {
        dispatch(newRoomFail(res.message));
        dispatch(actions.applicationError(res.message));
      });
  };
}

export const setActiveRoom = id => {
  return {
    type: actionTypes.SET_ACTIVE_ROOM,
    payload: { activeRoom: id }
  };
};

export const getRoomById = id => {
  return dispatch => {
    window.flow
      .getRoomById(id)
      .then(res => { })
      .catch(res => {
        if (res.type === "login") {
          dispatch(actions.logout());
        }
      });
  };
};

export const addClipsToRoom = (roomId, clipId) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.ADD_CLIP_TO_ROOM_START });
    window.flow.showroomAddClip(roomId, clipId).then(res => {
      dispatch({ type: actionTypes.ADD_CLIP_TO_ROOM_SUCCESS });
    }).catch(res => {
      dispatch({ type: actionTypes.ADD_CLIP_TO_ROOM_FAIL });
      dispatch(actions.addMessage('popup.title.room.add.fail', null, 'text', 'dialog'));
    });
  };
};

const removeClipFromRoomSuccess = (roomId, clipId, type) => {
  return {
    type: actionTypes.REMOVE_CLIP_FROM_ROOM_SUCCESS,
    payload: { roomId: roomId, clipId: clipId, type: type }
  };
};

const removeClipFromRoomStart = (roomId, clipId) => {
  return {
    type: actionTypes.REMOVE_CLIP_FROM_ROOM_START,
    payload: { roomId: roomId, clipId: clipId }
  };
};

const removeClipFromRoomFail = (roomId, clipId) => {
  return {
    type: actionTypes.REMOVE_CLIP_FROM_ROOM_FAIL,
    error: "Could not remove clip",
    payload: { roomId: roomId, clipId: clipId }
  };
};

export const removeClipFromRoom = (roomId, clipId, type) => {
  return (dispatch, getState) => {
    dispatch(removeClipFromRoomStart(roomId, clipId));
    window.flow.showroomRemoveClipById(roomId, clipId).then(res => {
      let state = getState();
      let type = MediaType.getMediaType(state.clip.clips[clipId].media, state.clip.clips[clipId].mediafiles);
      dispatch(removeClipFromRoomSuccess(roomId, clipId, type)); // wird nicht ausgeführt
      // reload cliplist
      // wird nicht gebraucht, da reload beim klicken erfolgt
      //dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_ROOM, roomId));
    })
      .catch(res => {
        dispatch(removeClipFromRoomFail(roomId, clipId));
      });
  };
};
const removeClipsFromRoomSuccess = (projectId, clipIds) => {
  return {
    type: actionTypes.REMOVE_CLIPS_FROM_ROOM_SUCCESS,
    payload: { projectId: projectId, clipIds: clipIds }
  };
};

const removeClipsFromRoomStart = (projectId, clipIds) => {
  return {
    type: actionTypes.REMOVE_CLIPS_FROM_ROOM_START,
    payload: { projectId: projectId, clipIds: clipIds }
  };
};

const removeClipsFromRoomFail = (projectId, clipIds) => {
  return {
    type: actionTypes.REMOVE_CLIPS_FROM_ROOM_FAIL,
    error: "Could not remove clips",
    payload: { projectId: projectId, clipIds: clipIds }
  };
};

export const removeClipsFromRoom = (roomId, clipIds) => {
  return (dispatch, getState) => {
    dispatch(removeClipsFromRoomStart(roomId, clipIds));
    window.flow
      .showroomRemoveClipById(roomId, clipIds)
      .then(res => {
        // let state = getState();
        dispatch(removeClipsFromRoomSuccess(roomId, clipIds));
        // reload cliplist
        dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_ROOM, roomId));
        dispatch(actions.addMessage('popup.title.room.remove.success', null, 'text', 'dialog'));
        if (DataUtil.isFrancetv()) {
          clipIds.split(",").forEach(item => {
            let updatedHistory = DataUtil.updateHistoryData(getState().auth.user.id, `${CustomTypes.DELETE_FROM_ROOM}_${roomId}`);
            if (updatedHistory) dispatch(actions.updateMetadata("clip", item, { history: updatedHistory }));
          });
        }
      })
      .catch(res => {
        console.log(res);
        dispatch(removeClipsFromRoomFail(roomId, clipIds));
        dispatch(actions.addMessage('popup.title.room.remove.fail', null, 'text', 'dialog'));
      });
  };
};

export const deleteRoom = roomId => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.DELETE_ROOM_START });
    window.flow.delShowroom(roomId).then(res => {
      dispatch(actions.addMessage('popup.title.room.delete.success', null, 'text', 'dialog'));
      dispatch({ type: actionTypes.DELETE_ROOM_SUCCESS, payload: { roomId: roomId } });
      dispatch(actions.getRooms());
      dispatch(actions.getRoomLimit(getState().app.modules.modules));
    }).catch(res => {
      dispatch(actions.addMessage('popup.title.room.delete.fail', null, 'text', 'dialog'));
      dispatch({ type: actionTypes.DELETE_ROOM_FAIL });
    });
  };
};

const copyRoomStart = () => {
  return {
    type: actionTypes.COPY_ROOM_START
  };
};

const copyRoomSuccess = (project, pType = "project") => {
  return {
    type: actionTypes.COPY_ROOM_SUCCESS,
    payload: { project: project, type: pType }
  };
};

const copyRoomFail = error => {
  return {
    type: actionTypes.COPY_ROOM_FAIL,
    error: error
  };
};

export const copyRoomAsProject = (room, copyType) => {
  return (dispatch, getState) => {
    dispatch(copyRoomStart());
    let name = room.title;
    let cliplist = getState().clipList.clipLists[room.id];
    let clips = null;
    if (copyType === "approved") {
      let allClips = getState().clipList.clips;
      let clipsToCopy = cliplist.clips.filter(id => {
        return ClipUtil.isSelectedInRoom(allClips[id], room.id);
      });
      clips = clipsToCopy.join();
    } else {
      clips = cliplist ? cliplist.clips.join() : null;
    }
    if (name && name !== "") {
      window.flow.newProject({ 'name': name }).then(res => {
        dispatch(actions.newProjectSuccess(res));

        window.flow.projectAddClip(res.id, clips, "forceadd").then(r1 => {
          // reload projects and  project tree
          dispatch(actions.getProjectTree());
          dispatch(actions.getProjects());
          dispatch(copyRoomSuccess(res, "project"));
          dispatch(actions.addMessage('popup.title.room.copy.success'));
        });
      })
        .catch(res => {
          dispatch(copyRoomFail(res.message));
          dispatch(actions.applicationError(res.message));
        });

    }

  };
};

export const duplicateRoom = (room, clipIds) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.DUPLICATE_ROOM_START });

    // remove not used properties
    let r = { ...room }
    r.title = r.title + ' (copy)';
    delete r.metadata;
    delete r.originalObject;
    delete r.customid;
    delete r.members;

    window.flow.newShowroom({ ...r }).then(res => {
      dispatch({ type: actionTypes.DUPLICATE_ROOM_SUCCESS });

      dispatch(actions.getRoomLimit(getState().app.modules.modules));

      if (clipIds) {
        window.flow.projectAddClip(res.id, clipIds, 'forceadd').then((r1) => {
          dispatch(actions.getRooms());
          dispatch(actions.addMessage('popup.title.room.duplicate.success'));
        });
      } else {
        dispatch(actions.addMessage('popup.title.room.duplicate.success'));
      }
    }).catch(res => {
      dispatch({ type: actionTypes.DUPLICATE_ROOM_FAIL });
      dispatch(actions.applicationError(res.message));
    });
  };
}

export const sendRoom = (roomId, metadata, testmode = false) => {
  return dispatch => {
    window.flow.sendShowroom(roomId, metadata, testmode).then(res => {
      dispatch(actions.addMessage('popup.title.room.send.success', null, 'text', 'dialog'));
    }).catch(res => {
      dispatch(actions.addMessage('popup.title.room.send.fail', null, 'text', 'dialog'));
    });
  };
};


export const roomMakeZip = (roomId, roomcustomid, mediafileids) => {
  return dispatch => {
    dispatch({ type: actionTypes.ROOM_MAKE_ZIP_START });
    window.flow.showroomMakeZip(roomId, roomcustomid, mediafileids).then(res => {

      dispatch({ type: actionTypes.ROOM_MAKE_ZIP_SUCCESS });
      dispatch(actions.addMessage('popup.title.room.zip.success', null, 'text', 'dialog'));
    }).catch(res => {

      dispatch(actions.addMessage('popup.title.room.zip.fail', null, 'text', 'dialog'));
      dispatch({ type: actionTypes.ROOM_MAKE_ZIP_FAIL });
    });
  };
};
